export const iconFontAwesomeMedicalHealthFilePrescription = (
	<i className="fa-solid fa-file-prescription"></i>
);
